"use client";
'use strict';

var React = require('react');

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value
 * @example
 * ```javascript
 * const previous = usePrevious<string>(value)
 * ```
 */
function usePrevious(value) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

exports.usePrevious = usePrevious;
//# sourceMappingURL=usePrevious.js.map
